import { ClientVerificationRequest } from "@common/models";
import { ClientService } from '@common/services';
import { flow, makeObservable, observable, runInAction } from "mobx";


export class ValidationViewStore {
    @observable isValid: boolean = true;
    @observable verifySent: boolean = false;
    @observable clientVerificationRequest: ClientVerificationRequest = {
        phone: '',
        email: ''
    };

    constructor(init?: Partial<ValidationViewStore>) {
        Object.assign(this, init);
        makeObservable<ValidationViewStore>(this, undefined, {
            autoBind: true
        });
    }

    //#region Flows

    validateCustomer = flow(function* (this: ValidationViewStore, request: ClientVerificationRequest) {
        if (request.phone && request.email)
            this.isValid = false;
        else if (!request.phone && !request.email)
            this.isValid = false;
        else {
            yield ClientService.validateCustomer(request, { showError: true }).then(() => {
                runInAction(() => {
                    this.clientVerificationRequest = request;
                    this.verifySent = true;
                });
            });
        }
    });

    //#endregion
}
